"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
export interface VisualViewportState {
  /** Visible height in px (shrinks when the virtual keyboard opens). */
  height: number;
  /**
   * Vertical offset of the visual viewport relative to the layout viewport.
   * On iOS this becomes non-zero when the user scrolls while the keyboard is
   * open. Use it as the `top` style on fixed panels so they stay anchored to
   * the visible area instead of drifting upward.
   */
  offsetTop: number;
}

/**
 * Tracks the visual viewport dimensions to correctly handle virtual keyboard
 * appearance on mobile (especially iOS, where the layout viewport does not
 * shrink when the keyboard opens — only the visual viewport does).
 *
 * Returns `undefined` during SSR / before the first browser measurement so
 * that the calling component can fall back to CSS-only values.
 */
export const useVisualViewport = () => {
  const $ = _c(2);
  const [state, setState] = useState(undefined);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const vv = window.visualViewport;
      if (!vv) {
        return;
      }
      const update = () => setState(prev => prev && prev.height === vv.height && prev.offsetTop === vv.offsetTop ? prev : {
        height: vv.height,
        offsetTop: vv.offsetTop
      });
      update();
      vv.addEventListener("resize", update);
      vv.addEventListener("scroll", update);
      return () => {
        vv.removeEventListener("resize", update);
        vv.removeEventListener("scroll", update);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return state;
};